import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    placeholders: { type: Array }
  }

  static targets = ['input', 'submitButton', 'focusButton']

  connect () {
    this.inputTargets.forEach(() => {
      this.toggleSubmitButtonState()
    })

    this.inputTargets.forEach(input => {
      input.addEventListener('input', this.toggleSubmitButtonState.bind(this))
    })
  }

  focusEffect (e) {
    e.target.focus()
    e.target.placeholder = ''
  }

  onFocusButtonClick () {
    this.inputTarget.focus()
    this.inputTarget.placeholder = ''
  }

  applySuggestion (e) {
    const text = e.target.textContent.trim()
    this.inputTarget.value = text

    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }))
    this.toggleSubmitButtonState()
  }

  setPlaceholder (e) {
    const index = this.inputTargets.indexOf(e.target)
    e.target.placeholder = this.placeholdersValue[index]
  }

  removePlaceholder () {
    this.inputTarget.placeholder = ''
  }

  toggleSubmitButtonState () {
    const allFilled = this.inputTargets.every(input => input.value.trim() !== '')
    this.submitButtonTarget.disabled = !allFilled
  }

  autoOpenTimeForm () {
    setTimeout(() => {
      this.submitButtonTarget.click()
    }, 100)
  }
}
